const menuBtn = document.querySelector('.header-mobile-menu-btn');
const mobileMenu = document.querySelector('.mobile-menu-backdrop');
const mobileMenuCloseBtn = document.querySelector('.mobile-close-btn');
const mobileMenuLinks = document.querySelectorAll('.mobile-menu a');

menuBtn.addEventListener('click', onMenuBtnClick);
mobileMenuCloseBtn.addEventListener('click', onMobileMenuCloseBtnClick);

mobileMenuLinks.forEach(link => {
  link.addEventListener('click', onMobileMenuLinkClick);
});

function onMenuBtnClick() {
  mobileMenu.classList.add('is-open');
  document.body.classList.add('no-scroll');
}

function onMobileMenuCloseBtnClick() {
  mobileMenu.classList.remove('is-open');
  document.body.classList.remove('no-scroll');
}

function onMobileMenuLinkClick(event) {
  mobileMenu.classList.remove('is-open');
  document.body.classList.remove('no-scroll');

  const targetId = event.target.getAttribute('href');
  if (targetId.startsWith('#')) {
    event.preventDefault();

    const targetSection = document.querySelector(targetId);
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
